import clsx from "clsx";

interface StatusBadgeProps {
  status: string;
  label?: string;
  className?: string;
}

export function StatusBadge({ status, label, className }: StatusBadgeProps) {
  return (
    <span className={clsx("status-badge", `status-${status}`, className)}>
      {label ?? status}
    </span>
  );
}
